import React, { useMemo, useState, useEffect, useRef } from "react";
import { useParams, useHistory } from 'react-router-dom';
import { Grid, IconButton, Paper, Tab, Tabs, Typography, CircularProgress } from '@mui/material';
import styled from "styled-components";
import { Box } from "@mui/system";
import MedicalHistory from "../MedicalHistory";
import HealthParameters from "../HealthParameters";
import PatientDetails from "../PatientDetails";
import { useSelector } from "react-redux";
import * as authService from "../../../services/mainService";
import { toast } from "react-toastify";
import { StyledLogo } from "../../../assets/styles/CommonStyles";
import { useStyles } from "../../../assets/styles/SidebarStyles";
import { useStyles as healthParamStyle } from "../../../assets/styles/PatientDashboardStyles";

import { usePatientHealthStyles } from "../../ui/Patient/style";
import { useHealthParameterStyles } from "../../ui/HealthParameters/style";
import { HealthParameterList } from "../../../constant/staticLists";
import moment from "moment";



const Container = styled(Grid)(({ theme }) => ({
    '& .MuiPaper-root': {
        width: '100%',
        minHeight: 'calc(100vh - 240px)',
        marginBottom: 1,
    },
    '& .MuiTypography-root': {
        fontFamily: 'Poppins',
        fontStyle: 'normal',
    },
    '& .pagetitle': {
        paddingTop: 70,
        '& .MuiTypography-root': {
            fontWeight: 500,
            fontSize: '32px',
            lineHeight: '42px',
            color: '#2B2B2B',
            '& + .MuiTypography-root': {
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: 14,
                lineHeight: '18px',
                color: '#5E5E5E'
            }
        },
        '& + .MuiGrid-root': {
            // paddingTop: 0,
        }
    }
}))

const StyledTabs = styled(Tabs)(({ theme, selectedItem, index }) => ({
    borderBottom: '1.2px solid #F5F5F7',
    '& .MuiTab-root': {
        justifyContent: 'start',
        alignItems: 'start',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '18px',
        color: '#5E5E5E',
    },
    '& .Mui-selected': {
        background: 'linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)',
        backgroundClip: 'text',
        textFillColor: 'transparent',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        border: '1px solid',
        borderImageSlice: 1,
        borderWidth: '0px 0px 1.2px',
        borderImageSource: 'linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)'
    }
}))

const StyledGrid = styled(Grid)`
&.css-480o17-MuiGrid-root>.MuiGrid-item {
    margin-left: '70px';
}
`;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other} >
            {value === index && (
                <Box sx={{ p: 3, ...index === 2 && { pt: 0 } }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const UserDetails = () => {
    const history = useHistory();
    const classes = useStyles();
    const commonClasses = healthParamStyle();
    const patientHealthClassses = usePatientHealthStyles();
    const useHealthParameterClasses = useHealthParameterStyles();
    const [value, setValue] = useState(0)
    const [qrData, setQRData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [getItemValue, setItemValue] = useState("");
    const [isButtonLoading, setButtonLoading] = useState(false);

    const [isHealthParamsLoading, setIsHealthParamsLoading] = useState(false);

    const queryParams = new URLSearchParams(window.location.search)
    const token = "token=" + queryParams.get('token');
    const { qrCodeDetails, userData } = useSelector((state) => ({
        qrCodeDetails: state.user.qrCodeDetails,
        userData: state.auth.userData
    }));
    const payroleId = useMemo(() => qrCodeDetails, [qrCodeDetails])
    console.log('commonClasses____', commonClasses);
    const newClasses = {
        ...commonClasses,
        ...patientHealthClassses, ...useHealthParameterClasses
    };

    console.log('newClasses___',newClasses);

    const [duration, setDuration] = React.useState(HealthParameterList.reduce((prev, cur) => {
        prev[cur.primaryKey] = 'w'
        return prev
    }, {}))

    const [date, setDate] = React.useState(HealthParameterList.reduce((prev, cur) => {
        const currentDate = moment(new Date()).format('YYYY-MM-DD')
        prev[cur.primaryKey] = currentDate // All cards start with same date
        return prev
    }, {}))

    console.log('prev________111',date);

    const prevDur = useRef(duration);
    const prevDate = useRef(date);

    const handleClick = (item) => {
        setOpenModal(true);
        setItemValue(!!item.primaryHeading ? item.primaryHeading : "Lipid Profile")
    }

    const syncAllCards = (newDuration, newDate) => {
        // Sync all durations
        setDuration(prev => {
            const updatedDurations = {}
            Object.keys(prev).forEach(key => {
                updatedDurations[key] = newDuration
            })
            return updatedDurations
        })

        // Sync all dates
        setDate(prev => {
            const updatedDates = {}
            Object.keys(prev).forEach(key => {
                updatedDates[key] = newDate
            })
            return updatedDates
        })
    }


    useEffect(() => {
        const currentDate = moment(new Date()).format('YYYY-MM-DD')
        syncAllCards('w', currentDate)
    }, [])

    // Modified duration effect with loader
    useEffect(async () => {
        let changed
        const preValues = Object.entries(prevDur.current)
        const values = Object.entries(duration)
        preValues.forEach((element, index) => {
            if (element[1] !== values[index][1]) changed = values[index]
        });
        prevDur.current = duration
        
        if (changed) {
            console.log('Duration changed - updating all health parameters:', changed);
            setIsHealthParamsLoading(true); // Start loading
            
            try {
                const res = await authService.qrcodeDetailPageAPI(token, { 
                    timezone: 'Asia/Calcutta', 
                    duration: changed[1],
                    date: new Date().toISOString().split('T')[0] 
                });
                
                if (res.response_type === "fail") {
                    toast.error(res?.response?.message, { 
                        position: "bottom-center", 
                        closeButton: false, 
                        autoClose: 1000, 
                        style: { width: 'auto', borderRadius: 8 } 
                    });
                } else {
                    setQRData(res?.response?.data)
                }
            } catch (error) {
                console.error('Error fetching health parameters:', error);
            } finally {
                setIsHealthParamsLoading(false); // End loading
            }
        }
    }, [duration])

    // Modified date effect with loader
    useEffect(async () => {
        let changed
        const preValues = Object.entries(prevDate.current)
        const values = Object.entries(date)
        preValues.forEach((element, index) => {
            if (element[1] !== values[index][1]) changed = values[index]
        });
        prevDate.current = date
        
        if (changed) {
            console.log('Date changed - updating all health parameters:', changed);
            setIsHealthParamsLoading(true); // Start loading
            
            try {
                const firstDurationKey = Object.keys(duration)[0]
                const currentDuration = duration[firstDurationKey]
                
                const res = await authService.qrcodeDetailPageAPI(token, { 
                    timezone: 'Asia/Calcutta', 
                    duration: currentDuration, 
                    date: changed[1]
                });
                
                if (res.response_type === "fail") {
                    toast.error(res?.response?.message, { 
                        position: "bottom-center", 
                        closeButton: false, 
                        autoClose: 1000, 
                        style: { width: 'auto', borderRadius: 8 } 
                    });
                } else {
                    setQRData(res?.response?.data)
                }
            } catch (error) {
                console.error('Error fetching health parameters:', error);
            } finally {
                setIsHealthParamsLoading(false); // End loading
            }
        }
    }, [date])

    useEffect(async () => {
        setIsHealthParamsLoading(true); // Start loading for initial data
        try {
            const res = await authService.qrcodeDetailPageAPI(token);
            if (res.response_type === "fail") {
                toast.error(res?.response?.message, { 
                    position: "bottom-center", 
                    closeButton: false, 
                    autoClose: 1000, 
                    style: { width: 'auto', borderRadius: 8 } 
                });
            } else {
                setQRData(res?.response?.data)
            }
        } catch (error) {
            console.error('Error fetching initial health parameters:', error);
        } finally {
            setIsHealthParamsLoading(false); // End loading
        }
    }, [])



    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    console.log('WRONG___', newClasses.mainHealthCont);

    console.log('datedatedatedatedate_public::', date);

    return (
        <Container  spacing={4} style={{ marginLeft: '70px',marginRight:"70px", paddingBottom: '140px' }}>
            {/* <div style={{ marginTop: '40px' }}>
                <StyledLogo
                    src={"/assets/img/image1.png"}
                    className={classes.iconStyle}
                    alt="User"
                />
            </div> */}

            <div className={classes.titleCont} style={{ marginTop: '40px', }}>
                <StyledLogo
                    src={"/assets/img/image1.png"}
                    alt="User"
                />
            </div>
            <Typography style={{ paddingBottom: '20px', paddingTop: '20px', fontWeight: '500', fontSize: '32px', lineHeight: '42px', color: '#2B2B2B' }}>Medical Details</Typography>


            <Paper elevation={1}>
                <Grid item xs={12}>
                    <StyledTabs value={value} onChange={handleChange} variant="scrollable">
                        {['Patient Details', 'Medical History', 'Health Parameters'].map((item, index) =>
                            <Tab label={item} {...a11yProps(index)} />
                        )}
                    </StyledTabs>
                </Grid>
                <Grid item xs={12} sx={{ paddingLeft: '16px' }}>
                    <TabPanel value={value} index={0}>
                        {qrData.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                            <CircularProgress
                                size={50}
                                thickness={5}
                            /> </div> : <PatientDetails data={qrData.PersonalDetails} />}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <MedicalHistory data={qrData.MedicalHistory} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <div className={newClasses.mainHealthCont}>
                            <Grid container justify="center" className={newClasses.secondaryMainHealth}>
                                <HealthParameters
                                    className={newClasses}
                                    list={HealthParameterList}
                                    duration={duration}
                                    setDuration={setDuration}
                                    handleClick={handleClick}
                                    date={date}
                                    setDate={setDate}
                                    isHideModalPop={true}
                                    healthParam={qrData.HealthParameters}
                                    setQRData={setQRData}
                                    token={token}
                                    isLoading={isHealthParamsLoading}
                                />

                            </Grid>
                             {isHealthParamsLoading && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(2px)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 9999,
                                        minHeight: '400px'
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 2,
                                            padding: 3,
                                            backgroundColor: 'white',
                                            borderRadius: 2,
                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        <CircularProgress 
                                            size={50} 
                                            thickness={4}
                                            sx={{ 
                                                color: '#2AAB6C' // Match your app's primary color
                                            }}
                                        />
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                color: '#666',
                                                fontWeight: 500,
                                                textAlign: 'center'
                                            }}
                                        >
                                            Loading Health Parameters...
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        </div>
                        {/* <HealthParameters data={qrData.HealthParameters} /> */}
                    </TabPanel>
                </Grid>
            </Paper>

            <Box
                sx={{
                    position: 'fixed',
                    bottom: { xs: 0, md: '16px' },
                    left: { xs: 0, md: '24px' },
                    right: { xs: 0, md: '24px' },
                    zIndex: 1200,
                    borderRadius: { xs: '0px', md: '16px' },
                    background: 'linear-gradient(90deg, #097EB7 0%, #2AAB6C 100%)',
                    padding: { xs: '16px', md: '20px 36px' },
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    boxShadow: '0 -4px 24px rgba(9, 126, 183, 0.3)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <Box
                        component="img"
                        src={"/assets/img/image1.png"}
                        alt="EMED4U"
                        sx={{ height: 44, background: '#fff', borderRadius: '10px', padding: '8px' }}
                    />
                    <Box>
                        <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: { xs: '18px', md: '22px' }, lineHeight: '28px' }}>
                            Your health, one touch away with EMED4U
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '14px', lineHeight: '20px', marginTop: '4px' }}>
                            Securely store medical records, share via QR, and connect with doctors. Create your free account today.
                        </Typography>
                    </Box>
                </Box>
                <Box
                    component="button"
                    onClick={() => history.push('/')}
                    sx={{
                        whiteSpace: 'nowrap',
                        background: '#fff',
                        color: '#097EB7',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '12px 28px',
                        fontSize: '15px',
                        fontWeight: 600,
                        fontFamily: 'Poppins',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.9 },
                    }}
                >
                    Create Account
                </Box>
            </Box>
        </Container>
    )
}

export default UserDetails;